import { useCallback, useState } from 'react'

function useHouseConsignmentDrawer() {
  const [openHouseConsignmentId, setOpenHouseConsignmentId] = useState<number | null>(null)

  const openHouseConsignment = useCallback((id: number) => {
    setOpenHouseConsignmentId(id)
  }, [])

  const closeDrawer = useCallback(() => {
    setOpenHouseConsignmentId(null)
  }, [])

  return {
    openHouseConsignmentId,
    openHouseConsignment,
    closeDrawer,
    isDrawerOpen: openHouseConsignmentId != null,
  }
}

export default useHouseConsignmentDrawer
